export default "assets/images/icons/back-2f4738b6.svg";